import * as amplitude from '@amplitude/analytics-browser';

import type { EventProps } from './DiscountForm';

const clickEvent = (message: string, eventProps: EventProps) => {
    amplitude.track(message, eventProps);
};

export {
    clickEvent,
};
